import type { Color } from "../types";
import type { ColorStringParser } from "./ColorStringParser";

/**
 * Parses "transparent" color string.
 */
export class TransparentStringParser implements ColorStringParser {
  /**
   * @inheritDoc
   */
  parse(colorString: string): Color | undefined {
    if (colorString !== "transparent") {
      return;
    }
    return [0, 0, 0, 0];
  }
}
